import Delivery from './delivery';
import DeliveryTab from './DeliveryTab';
import GeneralTab from './GeneralTab';
import PickupTab from './PickupTab';
import TableOrderingTab from './TableOrderingTab';
import Tables from './tables';
import WoltDriveOnboardingCard from './WoltDriveOnboardingCard';

export default {
  Delivery,
  DeliveryTab,
  GeneralTab,
  PickupTab,
  TableOrderingTab,
  Tables,
  WoltDriveOnboardingCard,
};
